import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'
import { NoteWrapper } from '../../../styledComponents/notes/noteWrapper/NoteWrapper'
import { TalkingPointsNote } from '../../../styledComponents/notes/TalkingPointsNote'

export const getTalkingPointsThView = () => {
  return (
    <div>
      <NoteWrapper noteContent={TalkingPointsNote}>
        <div>
          <Translation text={getFormedEltTranslation('support-table-talking-points')} />
        </div>
      </NoteWrapper>
    </div>
  )
}
